import React from 'react';

import { ResetPasswordPage } from '@vlabs/pages/auth';
import {
  DepartmentsPage,
  UserListPage, UserDetailsPage,
  RoleListPage, RoleDetailsPage,
  EventListPagePoint3,
  SearchPagePoint3,
} from '@vlabs/pages/point';
import { PermissionRoute } from '@vlabs/permissions';
import { Pages } from '@vlabs/uikit';
import {
  generatePath, Redirect, Route, Switch,
} from 'react-router-dom';

import { routes } from './routes';
import { CardPage } from '../pages/card-page/CardPage';
import { CardsAndListsPage } from '../pages/cards-and-lists/CardsAndListsPage';
import { EventDetailsPage } from '../pages/event-details/EventDetailsPage';
import { FacePage } from '../pages/face-page/FacePage';
// ponytail: replaced by EventListPageV2, keep for reference
// import EventListPage from '../pages/events/events/EventListPage';
import { CreateHandlerPage } from '../pages/handlers/create-handler';
import { EditHandlerPage } from '../pages/handlers/EditHandlerPage.jsx';
import { HandlerViewPage } from '../pages/handlers/handler-view';
import HandlerListPage from '../pages/handlers/HandlerListPage.jsx';
import OtherScenarioStepper from '../pages/handlers/preconfigured-scenarios/other/OtherScenarioStepper.jsx';
import { InfoPage } from '../pages/info-page/InfoPage';
import { ListDetailsPage } from '../pages/list-details/ListDetailsPage';
import { PermissionTagPage } from '../pages/permission-tag';
import { PermissionTagListPage } from '../pages/permission-tag-list';
import { SourceGroupPage } from '../pages/source-group';
import { SourceListPage } from '../pages/source-list';
import { SourceLivePage } from '../pages/source-live';
import { SourceStreamPage } from '../pages/source-stream';
import { ChartSettings } from '../pages/statistic/ChartSettings.jsx';
import { StatisticPage } from '../pages/statistic/StatisticPage.jsx';
import { Workspace } from '../pages/workspace/Workspace';

const EVENT_LIST_INCLUDED_ATTRIBUTES = [
  'gender', 'age', 'apparentGender', 'apparentAge', 'upperBody', 'lowerBody', 'headwear', 'backpack', 'map',
];

function EventListPagePoint3WithAttributes(): React.JSX.Element {
  return <EventListPagePoint3 includedAttributes={EVENT_LIST_INCLUDED_ATTRIBUTES} />;
}

function PointRouter(): React.JSX.Element {
  return (
    <Switch>
      {/* Map index */}
      {/* <Route path={routes.map.index} exact component={MapPage} /> */}

      {/* Roles */}
      <PermissionRoute
        authRule="roles"
        component={RoleListPage}
        exact
        path={routes.roles.list}
      />
      <PermissionRoute
        authRule="roles"
        component={RoleDetailsPage}
        path={routes.roles.view}
      />
      {/* Users */}
      <PermissionRoute
        authRule="users"
        component={UserListPage}
        exact
        path={routes.users.list}
      />
      <PermissionRoute
        authRule="users"
        component={UserDetailsPage}
        path={routes.users.view}
      />
      {/* Permission tags */}
      <PermissionRoute
        authRule="permission_tags"
        component={PermissionTagListPage}
        exact
        path={routes.permissionTags.list}
      />
      <PermissionRoute
        authRule="permission_tags"
        component={PermissionTagPage}
        path={routes.permissionTags.view}
      />
      {/* Departments */}
      <PermissionRoute
        authRule="departments"
        component={DepartmentsPage}
        exact
        path={routes.departments.list}
      />
      {/* Sources */}
      <PermissionRoute
        authRule="streams_fs"
        component={SourceListPage}
        exact
        path={routes.sources.list}
      />
      <PermissionRoute
        authRule="streams_fs"
        component={SourceGroupPage}
        path={routes.sources.groupView}
      />
      {/* Ретрансляция до streamView: без exact роут настроек матчит и /live (v5-префиксный матч) */}
      <PermissionRoute
        authRule="streams_fs"
        component={SourceLivePage}
        path={routes.sources.streamLive}
      />
      <PermissionRoute
        authRule="streams_fs"
        component={SourceStreamPage}
        path={routes.sources.streamView}
      />
      {/* Event archive v2 */}
      {/* ponytail: merged into /archive with EventListPageV2 */}
      {/* <PermissionRoute
        authRule="events_fs_archive"
        component={EventListPageV2}
        exact
        path={routes.events.archive2}
      /> */}

      {/* CardsAndLists index */}
      <PermissionRoute
        authRule={['cards', 'lists']}
        canMethod="oneof"
        component={CardsAndListsPage}
        path={routes.cardsAndLists.activeTab}
      />
      <Redirect
        exact
        from={routes.cardsAndLists.index}
        to={generatePath(routes.cardsAndLists.activeTab, { activeTab: 'cards' })}
      />
      {/* ponytail: routes.cards removed, redirect handled by cardsAndLists above */}
      {/* <Redirect
        exact
        from={routes.cards.index}
        to={generatePath(routes.cardsAndLists.activeTab, { activeTab: 'cards' })}
      /> */}

      {/* Search */}
      <PermissionRoute
        authRule="search"
        component={SearchPagePoint3}
        path={routes.search}
      />

      <PermissionRoute
        authRule="statistics_fs"
        component={StatisticPage}
        exact
        path={routes.events.statistic.all}
      />

      <PermissionRoute
        authRule="statistics_fs"
        component={ChartSettings}
        exact
        path={routes.events.statistic.read}
      />

      {/* [Clementine-auth] */}
      <Route
        component={ResetPasswordPage}
        path={routes.auth.reset}
      />

      {/* Monitoring */}
      <PermissionRoute
        authRule="monitoring"
        component={InfoPage}
        exact
        path={routes.app.info}
      />

      {/* [Luna] latest events */}
      <PermissionRoute
        authRule="operator_panel"
        component={Workspace}
        exact
        path={routes.events.latest}
      />

      {/* [Luna] events */}
      <PermissionRoute
        authRule="events_fs_archive"
        component={EventListPagePoint3WithAttributes}
        exact
        path={routes.events.archive}
      />

      {/* Events-Details */}
      <PermissionRoute
        authRule="event_fs_details"
        component={EventDetailsPage}
        exact
        path={routes.events.eventDetails}
      />

      {/* [Luna] handlers */}
      <PermissionRoute
        authRule="handlers"
        component={OtherScenarioStepper}
        exact
        path={routes.handlers.other}
      />
      <PermissionRoute
        authRule="handlers"
        component={CreateHandlerPage}
        path={routes.handlers.create}
      />
      <PermissionRoute
        authRule="handlers"
        component={HandlerViewPage}
        exact
        path={routes.handlers.read}
      />
      <PermissionRoute
        authRule="handlers"
        component={EditHandlerPage}
        path={routes.handlers.edit}
      />
      <PermissionRoute
        authRule="handlers"
        component={HandlerListPage}
        exact
        path={routes.handlers.all}
      />

      {/* [Luna] lists */}
      <PermissionRoute
        authRule="lists"
        component={ListDetailsPage}
        path={routes.lists.read}
      />
      <Redirect
        exact
        from={routes.lists.all}
        to={generatePath(routes.cardsAndLists.activeTab, { activeTab: 'lists' })}
      />

      {/* [Luna] faces */}
      <PermissionRoute
        authRule="cards"
        component={FacePage}
        path={routes.facePage}
      />

      <PermissionRoute
        authRule="cards"
        component={CardPage}
        path={routes.externalId.read}
      />

      {/* Router settings */}
      <Route
        exact
        path="/"
        render={() => <Redirect to={routes.events.latest} />}
      />
      <Route
        component={Pages.NotFoundPage}
        path="*"
      />
    </Switch>
  );
}

export { PointRouter };
